import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/goku/goku-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getAction } from "@api/manage";
import { replaceString } from "@/utils/Tool";
export function getDataJson(_x, _x2, _x3) {
  return _getDataJson.apply(this, arguments);
}

function _getDataJson() {
  _getDataJson = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cptDataForm, queryParam, cptType) {
    var resStr, iptStr, url;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            resStr = '{}'; //防止JSON解析报错

            iptStr = cptDataForm.dataText;

            if (!(cptDataForm.dataSource === 1)) {
              _context.next = 6;
              break;
            }

            resStr = JSON.parse(iptStr);
            _context.next = 21;
            break;

          case 6:
            if (!(cptDataForm.dataSource === 2)) {
              _context.next = 14;
              break;
            }

            //调接口
            iptStr = cptDataForm.apiUrl;

            if (!iptStr) {
              _context.next = 12;
              break;
            }

            url = replaceString(iptStr, queryParam) + "?cptType=".concat(cptType);
            _context.next = 12;
            return getAction(url).then(function (res) {
              resStr = res.result ? res.result : res;
            });

          case 12:
            _context.next = 21;
            break;

          case 14:
            if (!(cptDataForm.dataSource === 3)) {
              _context.next = 21;
              break;
            }

            iptStr = cptDataForm.sql;

            if (!iptStr) {
              _context.next = 21;
              break;
            }

            _context.next = 19;
            return getAction({
              sql: iptStr
            }).then(function (res) {
              resStr = res.data;
            });

          case 19:
            _context.next = 21;
            break;

          case 21:
            return _context.abrupt("return", resStr);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getDataJson.apply(this, arguments);
}

var cptTimer = {};
export function pollingRefresh(uuid, cptDataForm, loadData) {
  if (uuid) {
    clearInterval(cptTimer[uuid]); //清除旧的定时器
  }

  if (!cptDataForm) {
    return;
  }

  if (!loadData) {
    return;
  }

  loadData();

  if (cptDataForm.pollTime && cptDataForm.pollTime !== 0) {
    //轮询
    cptTimer[uuid] = setInterval(function () {
      loadData();
    }, cptDataForm.pollTime * 1000);
  }
}
export function clearCptInterval(uuid, clearAll) {
  if (uuid) {
    clearInterval(cptTimer[uuid]); //清除旧的定时器
  }

  if (clearAll) {
    for (var key in cptTimer) {
      clearInterval(cptTimer[key]);
    }
  }
}